<template>
  <b-server-table
    :key="renderKey"
    :filter-props="{
      filterMap: [
        {
          key: 'search',
        },
        {
          key: 'departmentId',
          directory: 'departmentList',
          component: 'select',
        },
        {
          key: 'typeId',
          directory: 'orderTypes',
          component: 'select',
        },
        {
          key: 'directionId',
          directory: 'orderDirections',
          component: 'select',
        },
        {
          key: 'issuedUserId',
          directory: 'userList',
          component: 'autocomplete',
        },
        {
          key: 'fromDate',
          component: 'input-date',
        },
        {
          key: 'toDate',
          component: 'input-date',
        },
        {
          key: 'isActive',
          component: 'checkbox',
        },
      ],
    }"
    :headers="orderListHeaders"
    :request-func="getOrders"
    @click:row="openRow">
    <template #action-button>
      <div v-if="can('orders.create')" class="d-flex ga-3">
        <v-btn rounded="lg" @click.stop="familiarizationReportDialog">
          <v-icon class="mr-1" style="color: #fff"
            >{{ 'mdi-cloud-print-outline' }}
          </v-icon>
          Сформувати звіт
        </v-btn>
        <v-btn rounded="lg" @click.stop="createOrder">
          <v-icon class="mr-1">mdi-plus</v-icon>
          Створити наказ
        </v-btn>
      </div>
    </template>
    <template #item.issuedUser="{ item }">
      <span v-if="item.issuedUser">
        {{ getPersonName(item.issuedUser) }}
      </span>
      <span v-else class="text-disabled">Не вказано</span>
    </template>
    <template #item.isActive="{ item }">
      <span>{{ item.isActive ? 'Активний' : 'Неактивний' }}</span>
    </template>
    <template #item.name="{ item }">
      <v-tooltip :text="item.name" bottom>
        <template #activator="{ props }">
          <span
            style="
              display: block;
              width: 350px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            v-bind="props">
            {{ item.name }}
          </span>
        </template>
      </v-tooltip>
    </template>
    <template #bottom></template>
  </b-server-table>
</template>

<script lang="ts">
import { axios, useBreadcrumb } from '@/plugins/index.js'
import { computed, ref } from 'vue'
import { navigateToItem } from '@/utils/helpers.js'
import { urlOrderList } from '@/utils/urls.js'
import { openDialog } from '@/dialog'
import { useStore } from 'vuex'
import { useCan } from '@/composables/useCan'
import { BServerTable } from 'best-modules/components'
import { getPersonName } from 'best-modules/utils'
import { orderListHeaders } from '@/utils/tableHeaders'

export default {
  components: { BServerTable },
  data: () => ({
    orderListHeaders,
  }),
  methods: { getPersonName },
  setup() {
    const store = useStore()
    const { can } = useCan()
    const renderKey = ref(1)
    const breadcrumb = useBreadcrumb()
    breadcrumb.set([], { type: 'replace' })

    const user = computed(() => store.state.user.userData || {})

    const openRow = (event: any) => {
      navigateToItem('single-order', event.id)
    }

    const getOrders = (query: any) => {
      return axios.get(urlOrderList(query)).then(res => res.data)
    }

    const familiarizationReportDialog = () => {
      openDialog({
        name: 'FamiliarizationReport',
        action: 'create',
      })
    }

    const createOrder = () => {
      openDialog({
        name: 'Order',
        action: 'create',
        params: {
          cb: order => {
            navigateToItem('single-order', order.id)
          },
          submitLabel: 'Створити',
        },
      })
    }

    return {
      renderKey,
      getOrders,
      navigateToItem,
      familiarizationReportDialog,
      openRow,
      user,
      createOrder,
      can,
    }
  },
}
</script>

<style lang="scss" scoped></style>
